// @ts-nocheck
/* eslint-disable */
import SceneMarkerMapyWindy from "./mapy-windy";

export default class SceneMarkerMapyWindySearch extends SceneMarkerMapyWindy {
	/**
	 * Vytvoreni Windy markeru pro hledani.
	 *
	 * @param  {SceneCoords} coords Vstupni souradnice
	 * @param  {Object} poi Vstupni POI data
	 * @param  {Object} [opts] Volitelny objekt s konfiguraci
	 */
	constructor(scene, itemId, coords?, poi?, opts?) {
		super(scene, itemId, coords, null, opts);

		this._poi = poi;
		this._titlePosition = "";
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	get featureInfo() {
		return {
			name: "SceneMarkerMapyWindySearch",
			type: "marker"
		};
	}

	get titlePosition() {
		return this._titlePosition;
	}

	/**
	 * Naplneni dat markeru z POI dat.
	 *
	 * @param  {Object} poi POI data
	 * @param  {String|Number} id Vlastni id
	 * @param  {Object} opts Konfigurace
	 */
	fromPOI(poi, id, opts = {}) {
		this._coords = this._scene.coordsFromWGS84(poi.mark.lon, poi.mark.lat);
		this._id = id || this._id;
		this._poi = poi;

		let typeId = "small";

		if (poi.markerId && poi.markerId != "universal") { typeId = poi.markerId; }

		let params = {
			type: this._scene.VISUAL.MARKER_WINDY[typeId.toUpperCase()] || {}
		};

		Object.assign(this._conf, Object.assign(params, opts));

		this._fromPOI = {
			poi: poi,
			id: id,
			opts: opts
		};
	}

	showTitleText(show, position) {
		this._titlePosition = position;
		this._onChange(this._scene.featureEvent("markerMapyWMShowTitle", true, true), arguments);
	}

	showFirmBadge(show) {
		this._onChange(this._scene.featureEvent("markerMapyWMShowFirmBadge", true, true), arguments);
	}

	setInteractive(set) {
		this._onChange(this._scene.featureEvent("markerMapyWMSetInteractive", true, true), arguments);
	}

	/**
	 * posunuti markeru o zadany pocet pixelu zleva a zhora
	 */
	set paddingPosition({ top, left }) {
		if (!top && !left) {
			this._paddingPosition = null;
		}
		else {
			this._paddingPosition = {
				...top !== undefined ? { top } : {},
				...left !== undefined ? { left } : {},
			};
		}

		return this._onChange(this._scene.featureEvent("markerMapyWMPaddingPosition", true, true), arguments);
	}
}
